module.exports = __webpack_public_path__ + "img/search.d6b2c2a1.svg";